<script>
import Vue from 'vue';
import store from '../../store'
import Alert from '../Alert/Alert.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import {mapState} from 'vuex';
import ContractManagementEditForm from '../ContractManagementEditForm/ContractManagementEditForm.vue';
import ContractManagementEditControl from '../ContractManagementEditControl/ContractManagementEditControl.vue';
import ContractManagementEditProgress from '../ContractManagementEditProgress/ContractManagementEditProgress.vue';
import ContractManagementEditEmail from '../ContractManagementEditEmail/ContractManagementEditEmail.vue';
import ContractBreadcrumb from '../ContractBreadcrumb/ContractBreadcrumb.vue';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        InfoWidget,
        ContractManagementEditForm,
        ContractManagementEditControl,
        ContractManagementEditProgress,
        ContractManagementEditEmail,
        ContractBreadcrumb,
    },
    computed: {
        ...mapState({
            tips: state => state.contract.tips,
            loading: state => state.contract.contractManagement.form.loading,
            contract: state => state.contract.contractManagement.item,
            user: state => state.auth.user,
        })
    },
    beforeRouteEnter (to, from, next) {
        store.dispatch('contract/getContractManagementByContractId', to.params.contractId).then(() => {
            store.dispatch('contract/getContractManagementSupplierData', to.params.supplierId).then(() => {
                store.dispatch('contract/getBrands').then(() => {
                    next();
                })
            })
        });
    },
    beforeRouteLeave(to, from, next) {
        Promise.all([
            store.dispatch('contract/resetContractManagementState'),
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    }
});
</script>
<template>
    <div class="contract-page">
        <loading v-if="loading"/>
        <contract-breadcrumb v-if="user && user.contractManager" :contract="contract"/>
        <contract-management-edit-progress/>
        <contract-management-edit-email/>
        <contract-management-edit-form/>
        <contract-management-edit-control/>

        <alert :translation-prefix="'contractManagement.alert'"/>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditPage/ContractManagementEditPage.vue